import React, {useState} from "react"
import {Button, ButtonText} from "../Components/Button"
import {Modal} from "../Components/Modal"
import {useLocal, useRoomSetup, useRoomParameters, useModal, useSolution} from "../AppContext"
import {MODAL__ADDITIONAL_SOLUTION_SUGGESTIONS} from "../Hooks/Modal"
import style from "./AdditionalSolutionSuggestions.css"
import saveRoomImageUrl from "../../assets/guides/save-room.jpg"
import {LoadIndicator} from "../Components/LoadIndicator"
import {useSuggestedSolutions} from "../Hooks/SuggestedSolutions"

export const AdditionalSolutionSuggestions = () => {
    const local = useLocal()
    const roomSetup = useRoomSetup()
    const roomParameters = useRoomParameters()
    const [isLoading, setIsLoading] = useState(false)

    return <Modal type={MODAL__ADDITIONAL_SOLUTION_SUGGESTIONS} userStyle={{width: "900px"}} bright={true}>
        <div className={style.layout}>
            <div>
                <div className={style.main}>
                    <div className={style.left}>
                        <div className={style.title}>
                            <span>{local.__("Was gefällt Ihnen? Ihre aktuelle Auswahl:")}</span>
                        </div>
                        <div className={style.content}>
                            <div className={style.list}>
                                {roomParameters.getImpressions(roomSetup.getType()).map(impression => <Impression key={impression.id} impression={impression}/>)}
                            </div>
                        </div>
                    </div>
                    <div className={style.right}>
                        <div className={style.title}>
                            <span>{local.__("Neue Vorschläge für Sie")}</span>
                        </div>
                        <div className={style.content}>
                            {local.__("Noch nicht fündig geworden? Gerne suchen wir für Sie weitere passende Vorschläge zusammen. Ihre aktuellen Vorschläge sind nun gespeichert, sie können jederzeit oben im Menü über \"Gespeicherte Räume\" wieder geladen werden.")}
                            <img src={saveRoomImageUrl} alt={local.__("Anleitung Raum speichern")}/>
                        </div>
                    </div>
                </div>
                {isLoading && <div className={style.loadIndicator}><LoadIndicator/></div>}
            </div>
            <Footer isLoading={isLoading} setIsLoading={setIsLoading}/>
        </div>
    </Modal>
}

const Impression = ({impression}) => {
    const roomSetup = useRoomSetup()
    const local = useLocal()

    if (!roomSetup.hasImpression(impression.id)) {
        return <></>
    }

    return <div>
        <img src={impression.image} alt={local.getLabel(impression.title)}/>
    </div>
}

const Footer = ({isLoading, setIsLoading}) => {
    const local = useLocal()
    const modal = useModal()
    const solution = useSolution()
    const roomSetup = useRoomSetup()
    const roomParameters = useRoomParameters()
    const suggestedSolutions = useSuggestedSolutions()

    const openEmptyRoom = async () => {
        const roomName = local.getLabel(roomParameters.getRoomTypeByCode(roomSetup.getType()).name)
        if (await solution.addPlanning([], roomName)) {
            solution.setPlanningIndex(solution.countPlannings() - 1)
        }
        modal.close()
    }

    const editSelectedSuggestions = () => {
        modal.close()
        modal.openSolutionSuggestions()
    }

    const createNewSuggestions = async () => {
        setIsLoading(true)

        const solutions = await suggestedSolutions.loadRaw(roomSetup.getId(), local.getLang(true))

        for(let i = 0 ; i < solutions.length; i++) {
            const products = solutions[i].products
            const name = local.getLabel(solutions[i].name)
            await solution.addPlanning(products, name)
        }

        solution.setPlanningIndex(solution.countPlannings() - solutions.length)
        setIsLoading(false)
        modal.close()
    }

    return <div className={style.footer}>
        <div className={style.left}>
            <div><ButtonText isDisabled={isLoading} onClick={editSelectedSuggestions}>{local.__("Aktuelle Auswahl bearbeiten")}</ButtonText></div>
        </div>
        <div className={style.right}>
            <div><ButtonText isDisabled={isLoading} onClick={openEmptyRoom}>{local.__("mit leerem Raum starten")}</ButtonText></div>
            <div><Button isDisabled={isLoading} onClick={createNewSuggestions}>{local.__("Neue Vorschläge erstellen")}</Button></div>
        </div>
    </div>
}

